import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
}), 'CallMissedOutgoing');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMissedOutgoing.js
// module id = 2605
// module chunks = 2